import {useSelector} from "react-redux";

import I18nErrorMessage from "../../component/I18nErrorMessage";
import {selectPersistenceError} from "../../redux/persistenceSelectors";
import {selectFinalizationError} from "../../redux/persistenceSlice";
import {selectError as selectSpecError} from "../../redux/specSlice";
import {selectError as selectValueIndicationError} from "../../redux/valueIndicationSlice";

export default function ErrorMessageContainer() {
    const indicationError = useSelector(selectValueIndicationError);
    const specError = useSelector(selectSpecError);
    const finalizationError = useSelector(selectFinalizationError);
    const persistenceError = useSelector(selectPersistenceError);
    const className = "grow-0 shrink-0 mb-4 w-full";

    return (
        <>
            <I18nErrorMessage errorObject={indicationError} className={className} />
            <I18nErrorMessage errorObject={specError} titleI18nKey="object.errorLoadingSpec" className={className} />
            <I18nErrorMessage
                errorObject={persistenceError}
                titleI18nKey="object.error.persistence"
                className={className}
            />
            <I18nErrorMessage
                errorObject={finalizationError}
                titleI18nKey="object.error.finalization"
                className={className}
            />
        </>
    );
}
